
const getHiddenData = () => {
  const data: Record<string, string> = {};
  const targetDiv = document.querySelector('div.field-page-topics')?.textContent;
  if (!targetDiv) return data;
  const key = 'field-page-topics'
  const value = targetDiv.trim()
  data[key] = value;
  return data;
}

export default getHiddenData;
